import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { UserService } from '../services/user.service';
import { OverlayService } from '../services/overlay.service';
import { visitAll } from '@angular/compiler';
import { Subscription } from 'rxjs';
import { PromotionService } from '../services/promotion.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
    currentUser: any
    // Template Variable
    pageHasStage: Boolean = true;
	noNav: Boolean = true;
    togglemenu: Boolean = false;
    toggleBenefitsNav: Boolean = false;
    isLoggedIn: Boolean = false;
    isAdmin: Boolean = false;
    isChildActive: Boolean = false;
    navigationSubscription: any;
    promoMessageSubscription: Subscription
    promoMessageChanged: Subscription
    promoMessageClosed: boolean = false

    constructor(
        private router: Router,
        private userService: UserService,
        private overlayService: OverlayService,
        private activatedRoute: ActivatedRoute,
        private promotionService: PromotionService
    ) {
        this.isLoggedIn = this.userService.isLoggedin()
        this.isAdmin = this.userService.isAdminUser()
        this.router.events.filter((event) => event instanceof NavigationEnd).map(() => this.activatedRoute).map((route) => {
            this.isLoggedIn = this.userService.isLoggedin()
            this.isAdmin = this.userService.isAdminUser()
            window.scrollTo(0, 0)
            while (route.firstChild) route = route.firstChild
			return route;
		}).filter((route) => route.outlet === 'primary').mergeMap((route) => route.data).subscribe((event) => {
            this.pageHasStage = false
            this.togglemenu = false
			this.noNav = false;
			if (event['noNav']) {
				this.noNav = true;
			}
            if (event['stage']) {
                this.pageHasStage = true;
			}
        });
        // this.openSearchOverlay()

        this.navigationSubscription = this.router.events.subscribe(val => {
            if (val instanceof NavigationEnd) {
                if (!val.url.startsWith('/who-benefits')) {
                    this.isChildActive = false
                } else if (val.url.startsWith('/who-benefits')) {
                    this.isChildActive = true
                }
            }
        })
    }

    ngOnInit() {
        if (localStorage.getItem('promotion-closed') === 'true') {
            this.promoMessageClosed = true
        } else {
            this.promoMessageClosed = false
        }
        this.userService.getCurrentUser()
        this.userService.currentUser.subscribe((currentUser) => {
            this.currentUser = currentUser
        })

        this.promoMessageSubscription = this.promotionService.promoMessageClosed.subscribe((message: string) => {
			if (message === 'promotion message closed') {
                this.promoMessageClosed = true
			} else {
                this.promoMessageClosed = false
            }
        })

        this.promoMessageChanged = this.promotionService.promoMessageChanged.subscribe((res: any) => {
			if (res.message === 'promotion message updated') {
				const promoObj = res.obj
				if (promoObj.displayPromotionStrip) {
					this.promoMessageClosed = false
				} else {
					this.promoMessageClosed = true
				}
			}
		})
    }

    ngOnDestroy() {
        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe()
        }
        if (this.promoMessageSubscription) {
            this.promoMessageSubscription.unsubscribe()
        }
        if (this.promoMessageChanged) {
            this.promoMessageChanged.unsubscribe()
        }
    }

    childLinkClicked() {
        this.linkClicked()
        this.isChildActive = true;
    }

    logout() {
        this.userService.logout()
    }

    linkClicked() {
        this.togglemenu = false
        this.toggleBenefitsNav = false
    }
}



// WEBPACK FOOTER //
// ./src/app/common/header.component.ts